import { GET_INTERESTS_FAIL, GET_INTERESTS_REQUEST, GET_INTERESTS_SUCCESS, GET_PROFILES_FAIL, GET_PROFILES_REQUEST, GET_PROFILES_SUCCESS, GET_PROFILE_FAIL, GET_PROFILE_REQUEST, GET_PROFILE_SUCCESS, UPDATE_PROFILE_FAIL, UPDATE_PROFILE_REQUEST, UPDATE_PROFILE_SUCCESS } from "../types";

export const ProfileDetailsReducer = (
  state = { error: null, profile: {interests: []} },
  action
) => {
  switch (action.type) {
    case GET_PROFILE_REQUEST:
      return { ...state, loading: true };
    case GET_PROFILE_SUCCESS:
      return { ...state, loading: false, profile: action.payload };
    case GET_PROFILE_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export const ProfileListReducer = (
  state = { error: null, profiles: [] },
  action
) => {
  switch (action.type) {
    case GET_PROFILES_REQUEST:
      return { ...state, loading: true };
    case GET_PROFILES_SUCCESS:
      return { ...state, loading: false, profiles: action.payload };
    case GET_PROFILES_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};


  export const ProfileUpdateReducer = (
    state = { error: null, success: false },
    action
  ) => {
    switch (action.type) {
      case UPDATE_PROFILE_REQUEST:
        return { ...state, loading: true };
      case UPDATE_PROFILE_SUCCESS:
        return { ...state, loading: false, success: true };
      case UPDATE_PROFILE_FAIL:
        return { ...state, loading: false, error: action.payload };
  
      default:
        return state;
    }
  };

  export const InterestsListReducer = (
    state = { error: null, interests: [] },
    action
  ) => {
    switch (action.type) {
      case GET_INTERESTS_REQUEST:
        return { ...state, loading: true };
      case GET_INTERESTS_SUCCESS:
        return { ...state, loading: false, interests: action.payload };
      case GET_INTERESTS_FAIL:
        return { ...state, loading: false, error: action.payload };
  
      default:
        return state;
    }
  };

  